
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* Elementary Algebra 1e */ '0889907c-f0ef-496a-bcb8-2a5bb121717f': [
    /* Elementary Algebra 2e */ ['55931856-c627-418b-a56f-1dd0007683a8', {
      /* Preface to the same module in 2e */
      '4b5aaf32-1de1-419b-bdc0-4e0a7f6daf0f' :	'4b5aaf32-1de1-419b-bdc0-4e0a7f6daf0f',
      /* 1.0 Introduction	to the same module in 2e */
      '19f69697-5186-45fe-a4b8-3c4917b17901' :	'bc4f2db1-1010-454d-acef-93759bc783d9',
      /* 1.1  Introduction to Whole Numbers 	to the same module in 2e */
      'ccc2dd77-ffc3-49aa-a27d-e7087faebcbe' :	'16b0b665-bb17-4b27-886f-08a966ee6c79',
      /* 1.2 Use the Language of Algebra 	to the same module in 2e */
      '7da1d1a3-bb58-4717-b20f-cfe52cff4a20' :	'7c6afafa-02d2-4a6b-8aa7-26905730d112',
      /* 1.3 Add and Subtract Integers 	to the same module in 2e */
      '94199560-1b2d-473e-83e6-a1737343a724' :	'010c545d-1554-49a3-b076-132855c98436',
      /* 1.4 Multiply and Divide Integers	to the same module in 2e */
      '0e0913e4-acbf-4348-b7bf-0b337da866cb' :	'e1538584-9fa6-4c61-be47-6cefb25a54ad',
      /* 1.5 Visualize Fractions	to the same module in 2e */
      '1d187324-616a-4ce7-a65a-4c6ab0a2820b' :	'1f630730-e8df-4e11-9716-3462e4a50d91',
      /* 1.6  Add and Subtract Fractions 	to the same module in 2e */
      'b371ea6f-920c-4d24-8386-ccf75f3c8c9c' :	'e66747c7-79a1-4702-9997-019f59474d18',
      /* 1.7 Decimals 	to the same module in 2e */
      '35c889d6-a6b4-4411-a132-917996116ba2' :	'cf181a65-4991-4731-8f57-56f92ba6ae42',
      /* 1.8 The Real Numbers	to the same module in 2e */
      '76007648-78b4-4ea5-b890-d42b1c31b73d' :	'addd5899-22fe-4839-98ab-796b22867e38',
      /* 1.9  Properties of Real Numbers	to the same module in 2e */
      'c291c182-70e2-4b34-b0ca-9d00cee6b0f7' :	'4872eb92-e2a7-44bc-a560-95441f7abc20',
      /* 1.10 Systems of Measurement	to the same module in 2e */
      'f4239154-637a-456d-bd15-3c32773c215f' :	'69fe7540-4ca9-4cf1-8e7c-cfd3d94cf3fc',
      /* 2.0 Introduction	to the same module in 2e */
      '5f5fdd66-80ef-49e3-b527-6956a1ae8866' :	'c591f886-799f-41d7-b3de-c43a547ed8ed',
      /* 2.1  Solve Equations Using the Subtraction and Addition Properties of Equality	to the same module in 2e */
      '396a649f-cfc6-434d-8313-334605f89519' :	'16401322-10a2-4be5-9d4a-efd5ccbe091f',
      /* 2.2  Solve Equations Using the Division and Multiplication Properties of Equality	to the same module in 2e */
      'f6e8ed8b-0a46-4b90-ba34-82804fcf46db' :	'b879afa3-111c-4c63-a6fd-751ce025accd',
      /* 2.3  Solve Equations with Variables and Constants on Both Sides	to the same module in 2e */
      '9b9091a2-3184-4675-86b7-dd1f9c72edcf' :	'0a4b0d7e-4ba8-4238-a334-a318d1fb868f',
      /* 2.4  Use a General Strategy to Solve Linear Equations	to the same module in 2e */
      'a015652a-8f79-4e32-8543-3a26a55d228d' :	'b60c723d-8e0b-4b56-9594-dba6dd21d116',
      /* 2.5  Solve Equations with Fractions or Decimals 	to the same module in 2e */
      '8f7fdafc-586d-4b77-9d77-bf727df1f644' :	'298d833c-c21e-4d03-a6e0-05bf439099e9',
      /* 2.6  Solve a Formula for a Specific Variable	to the same module in 2e */
      'b99741c4-41ad-4678-80e5-2f3b4e60303b' :	'dbf74c23-da9a-4bc4-928d-31acbb00c054',
      /* 2.7  Solve Linear Inequalities	to the same module in 2e */
      'e062ba25-2428-41b0-82f0-fbfd839e87fd' :	'173c310c-48fa-4aac-acb7-2aadea74b016',
      /* 3.0 Introduction	to the same module in 2e */
      'b0eaedad-e445-40af-bd34-e5e4fcdabefd' :	'73eb701f-e290-43bb-9b91-54ae816cace9',
      /* 3.1  Use a Problem-Solving Strategy 	to the same module in 2e */
      '4e3f3b11-3091-4e62-b994-28864a60e70f' :	'92a2ac6e-a957-49f1-9cb7-2f1bbfb0b138',
      /* 3.2 Solve Percent Applications 	to the same module in 2e */
      '44c0bf88-129a-4ac5-ac12-831451623aed' :	'09c48016-b1c8-4c13-858a-5d960474e1ed',
      /* 3.3 Solve Mixture Applications  	to the same module in 2e */
      '67cb13c1-c8c4-46f9-b9dc-69ced65ae0f9' :	'9f4a54b3-d6e2-4dca-a880-00e1c8384366',
      /* 3.4  Solve Geometry Applications: Triangles, Rectangles and the Pythagorean Theorem	to the same module in 2e */
      '056e9b31-4426-432b-892e-dbf472e10fd1' :	'53733266-6977-4051-be03-caee623171cf',
      /* 3.5 Solve Uniform Motion Applications	to the same module in 2e */
      '0edeb26f-6a6b-42fa-b41a-e6a5e41d7e16' :	'f61a6787-6140-47e0-a73c-4cc6e4075c5b',
      /* 3.6 Solve Applications with Linear Inequalities	to the same module in 2e */
      '4c7a572e-54b3-419c-8478-4840525e76b9' :	'd2477892-2675-4e35-99d1-24d68764ff65',
      /* 4.0 Introduction	to the same module in 2e */
      '7bcbe311-ae9a-4ae4-81c6-2bd09d935531' :	'95f8d968-f53e-47e8-b50e-3d4ed1be5fa3',
      /* 4.1  Use the Rectangular Coordinate System 	to the same module in 2e */
      '4ba104ac-66f9-440a-a31d-ba9cff94784b' :	'92b817ea-0ce2-48e0-a81e-3af9aacf22bc',
      /* 4.2  Graph  Linear Equations in Two Variables to the same module in 2e */
      'ba853849-9e0e-4c65-9709-683d2575b1a6' :	'cee29c47-8e40-4e4e-b444-74344bc59cc2',
      /* 4.3  Graph with Intercepts	to the same module in 2e */
      'e59a8126-4e00-42a2-b771-e0eab4a5faad' :	'3b10d74a-8efd-49e2-a27d-8c86baf5adcc',
      /* 4.4  Understand Slope of a Line 	to the same module in 2e */
      'ba42b46c-de39-4f91-a515-06bfd7a16c6b' :	'253ec23a-c6f2-469c-b8d5-e3eb6dd3152b',
      /* 4.5 Use the Slope-Intercept Form of an Equation of a Line	to the same module in 2e */
      'b5e815e3-05c6-477a-b6bc-85303b9548a9' :	'a0f9652e-2e99-4e85-a596-59c8366ed67c',
      /* 4.6 Find the Equation of a Line	to the same module in 2e */
      'fcb10455-670c-4833-808a-5b0cfe84e439' :	'f22792f2-8313-4602-ab5f-cf883a91fcb1',
      /* 4.7 Graphs of Linear Inequalities	to the same module in 2e */
      'd5f3a801-b391-4016-82de-76dd95baf52d' :	'08afbc20-10b0-4a72-b3a5-7cfa435f4e5a',
      /* 5.0 Introduction	to the same module in 2e */
      'c1713842-e3eb-43d7-b13b-9c311928ae5e' :	'420fa0a2-aa19-4089-9e1d-b6d57dbd10ed',
      /* 5.1 Solving Systems of Equations by Graphing	to the same module in 2e */
      '0f99f6b2-0cf7-40ba-afec-7d2b9b592615' :	'de57f139-b962-4af1-b9a2-c16e5d79b8f0',
      /* 5.2 Solving Systems of Equations by Substitution	to the same module in 2e */
      '8cb1a567-a9b9-4da7-9474-081c7d79e739' :	'48a0bef6-8813-4d11-9a11-1a274213a2d4',
      /* 5.3 Solving Systems of Equations by Elimination	to the same module in 2e */
      '57511fdb-a26a-445e-8200-0d37b67fef16' :	'791e7337-c879-4371-af7a-0095ed095992',
      /* 5.4 Solve Applications with Systems of Equations	to the same module in 2e */
      '640ad2d5-9d0f-4d4e-9d1a-9878b95af41f' :	'3e515ef1-d4c8-43d7-a586-b47128a0029e',
      /* 5.5 Solve Mixture Applications with Systems of Equations	to the same module in 2e */
      'e4f6a4a0-4237-4e23-ac24-ae46c237a66b' :	'09a3f5b3-80de-4fb7-8be6-7e2be34f4b97',
      /* 5.6 Graphing Systems of Linear Inequalities	to the same module in 2e */
      'bc5966b9-fd87-4280-88c6-7a9473cb2369' :	'529d0570-5090-42a7-8395-8449d6a5dda3',
      /* 6.0 Introduction	to the same module in 2e */
      '0c1894a0-8db7-4df2-9873-a04e30172e71' :	'ee75f212-52b7-42df-a9e1-85575033d0fd',
      /* 6.1  Add and Subtract Polynomials  	to the same module in 2e */
      '49a76b85-46b0-423f-b63d-4ab237922d6d' :	'e9e64a0e-91cd-4b39-b612-ebdfd1094df2',
      /* 6.2 Use Multiplication Properties of Exponents 	to the same module in 2e */
      '5e9abce2-d7cb-4205-b2fc-ef35881a9362' :	'dc17dc72-6aa5-4634-9f16-8d18aa7f9b8c',
      /* 6.3  Multiply Polynomials  	to the same module in 2e */
      '51e15f69-c2bd-4806-8edb-cfbaf5b86aa1' :	'c478da30-8375-479d-b509-c53a7e323f6a',
      /* 6.4  Special Products     	to the same module in 2e */
      '477bdc24-8900-42f0-a58b-b93af8fb9149' :	'7dabdf2f-b279-41b5-8346-2c7f5e9341a7',
      /* 6.5  Divide Monomials  	to the same module in 2e */
      'e4af7bbf-c6cc-48df-a992-7875445487d5' :	'd35cd09d-20bc-4df2-8549-646a5fb48e04',
      /* 6.6  Divide Polynomials 	to the same module in 2e */
      '4925ce3f-da01-4b3b-b918-a8d1447e22bf' :	'43c71564-b73e-4f33-b77b-12b0d0ff1868',
      /* 6.7 Integer Exponents and Scientific Notation 	to the same module in 2e */
      '8bf9f6fe-f9f5-41d1-ae78-89865b31ed51' :	'04016147-5b64-41c3-97e7-b0404eb7b6c5',
      /* 7.0 Introduction	to the same module in 2e */
      '8e357430-6a74-4e27-a15c-54fff659e923' :	'c3100e8f-d924-4baa-879c-3ba978e19132',
      /* 7.1 Greatest Common Factor and Factor by Grouping 	to the same module in 2e */
      '0e0ca183-6e11-4537-a2c7-5efc8fdc8a98' :	'd4018972-c461-49b5-a6a8-0391cacc62c0',
      /* 7.2  Factor Trinomials of the Form x2+bx+c     	to the same module in 2e */
      '29e914ae-d063-4fad-ba18-7af50ccf68e9' :	'641d8962-9051-4a14-9848-38fa45686aac',
      /* 7.3  Factor Trinomials of the Form ax2+bx+c 	to the same module in 2e */
      '9ed2c78a-ebd9-4fbd-815b-bc725e4ac70f' :	'2aa2f634-87f2-4609-a5a9-45267ecf453c',
      /* 7.4  Factor Special Products	to the same module in 2e */
      'a7eef984-e44e-41b2-af49-c07c9ccaa22e' :	'57be49ed-4d14-45cd-ac39-3ffebcf5398d',
      /* 7.5  General Strategy for Factoring Polynomials	to the same module in 2e */
      '528bee29-9976-44db-a525-7a4096ea1fb4' :	'41718022-4020-45f1-8c9a-4c4389a0c49c',
      /* 7.6 Quadratic Equations	to the same module in 2e */
      '0c7875f0-7368-4faf-b91e-e93d118b7369' :	'07099907-f174-4ffa-a900-763880e8b6e6',
      /* 8.0 Introduction	to the same module in 2e */
      '25637bf9-9200-4d93-b216-eb06045a3265' :	'b26f2452-440b-4281-9b3a-e2556aee68f9',
      /* 8.1  Simplify Rational Expressions 	to the same module in 2e */
      '58877794-2521-47bd-beaf-9c21b0f14c3d' :	'92766201-cd6f-4b2d-91c4-11532a85026e',
      /* 8.2  Multiply and Divide Rational Expressions	to the same module in 2e */
      '1f5048e5-d58e-4fe6-8bd0-9454d0170810' :	'293808cd-9b7e-494b-90e8-38acd2b23bd4',
      /* 8.3  Add and Subtract Rational Expressions with a Common Denominator 	to the same module in 2e */
      '435c819f-ec19-4023-b042-036df42b0f27' :	'0035f62a-18b7-42d0-a4b1-b327d51f9ccc',
      /* 8.4  Add and Subtract Rational Expressions with Unlike Denominators	to the same module in 2e */
      'f7fb46b9-30d4-45c1-a93e-05f874ac35cc' :	'eeeb43b2-685c-460e-8f2d-b4c1a0e36c8b',
      /* 8.5  Simplify Complex Rational Expressions	to the same module in 2e */
      '42239777-d2f7-42c9-8ac6-28dd5b870e76' :	'c37c3b56-a431-4e1d-a80b-0810cb6c2ab7',
      /* 8.6  Solve Rational Equations	to the same module in 2e */
      '943dbb7d-5ca9-4af9-9eb2-cfb4874fc544' :	'216ca2a3-d869-4681-a9a3-019274ec865a',
      /* 8.7 Solve Proportion and Similar Figure Applications	to the same module in 2e */
      'b363da9d-aeb9-4e0f-b61c-30dba51042ac' :	'10caf198-735d-4ef2-b703-491954c5e4f6',
      /* 8.8 Solve Uniform Motion and Work Applications	to the same module in 2e */
      'a44cc866-b480-4f33-92a7-15a216a5b5a6' :	'06cf042d-6c4b-4514-b5a0-54efd3f528f7',
      /* 8.9 Use Direct and Inverse Variation  	to the same module in 2e */
      'fcbf5597-0b61-4059-97a5-4740a7006940' :	'af900d35-933b-4191-a435-809fa26696cb',
      /* 9.0 Introduction	to the same module in 2e */
      'f83c9b52-7ec5-4fe3-9db0-59374c02041a' :	'af2714fb-c265-411e-b20e-e46e48435dbe',
      /* 9.1 Simplify and Use Square Roots	to the same module in 2e */
      '0f222fd1-4787-4c06-a0da-255c0ec2ed1a' :	'8eb3886c-2d06-4524-a96b-5d275f2b2f5d',
      /* 9.2 Simplify Square Roots	to the same module in 2e */
      'c03077b2-3e3a-48bc-a13b-9fa53a6a3b47' :	'b6f86a79-3398-4a84-8726-2f896582e2c9',
      /* 9.3 Add and Subtract Square Roots	to the same module in 2e */
      'bdf3d181-8a16-4bc8-b677-8aabeceff032' :	'd0995db9-8167-4fa2-b584-90bd9c253119',
      /* 9.4 Multiply Square Roots	to the same module in 2e */
      '2b9f5e67-76a2-4820-a190-7d64b849223d' :	'bcbc1c40-7eed-4846-b94e-87faab459c63',
      /* 9.5 Divide Square Roots	to the same module in 2e */
      'db433607-93ad-4dfb-a35d-9342a0484608' :	'3c41b502-5227-4324-a37c-f5cbbe45d25d',
      /* 9.6 Solve  Equations with Square Roots	to the same module in 2e */
      '78e1fea6-57ae-4e55-9fdd-b541423cb1c8' :	'8ed3f0af-9c2b-4129-bd0d-14a85cd1b14c',
      /* 9.7 Higher Roots 	to the same module in 2e */
      'b55c5836-305b-49b1-a6e4-7f0eb56671c6' :	'bd97dec6-0e78-47b4-af5e-b873cd643275',
      /* 9.8 Rational Exponents	to the same module in 2e */
      'fedd1ad3-fc37-478c-9e0b-79c9f9ff9c12' :	'cdd62d03-9da2-4bec-9691-8dbf0d69cf37',
      /* 10.0 Introduction	to the same module in 2e */
      'e2bb85b5-b2f5-46d9-b43c-73b8df9d75da' :	'92bc8256-9427-4946-92d8-caeaee6ba11c',
      /* 10.1 Solve Quadratic Equations Using the Square Root Property	to the same module in 2e */
      '5e4f27ba-1adb-47ad-9576-acfc17a81c48' :	'15bd47bf-b8c3-40e4-b4ba-2c213f4e5c98',
      /* 10.2 Solve Quadratic Equations By Completing the Square	to the same module in 2e */
      '6ecf6865-a29b-409f-bab1-8a5748e050e0' :	'c5628fd1-0a50-432b-b7a7-163be5d7a802',
      /* 10.3 Solve Quadratic Equations Using the Quadratic Formula	to the same module in 2e */
      '9b0c900a-92a8-437a-bb9b-34cd4aac12e8' :	'f700dd35-ce03-4200-996d-305c830b5fd8',
      /* 10.4 Solve Applications Modeled by Quadratic Equations	to the same module in 2e */
      '4cbd36fa-266a-4c75-835e-66e8a01799a4' :	'605ed621-f22d-49ae-98ce-a2c689d827e1',
      /* 10.5 Graphing Quadratic Equations in Two Variables	to the same module in 2e */
      '8c5c1b1f-5b72-40d9-8782-60f5a372862d' :	'4b20f567-8125-4283-894b-ff9d15897555',
    }],
  ],
} as CanonicalBookMap;
